// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__yNacb","errorLogs":"styles_errorLogs__1q-V_"};